import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/boiling-point-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/boiling-point-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/boiling-point-calculator",
      title: m.bp_meta_title(),
      description: m.bp_meta_description(),
      toolName: m.bp_tool_name(),
      faqs: [
        { q: m.bp_faq_q1(), a: m.bp_faq_a1() },
        { q: m.bp_faq_q2(), a: m.bp_faq_a2() },
        { q: m.bp_faq_q3(), a: m.bp_faq_a3() },
        { q: m.bp_faq_q4(), a: m.bp_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
